import useSocket from "hooks/useSocket";
import { useEffect, useRef } from "react";
import { SOCKET_SERVER_NAMESPACES } from "static/constants";

const useNotificationSocket = ({ refetchNotification } = {}) => {
  const socket = useSocket(SOCKET_SERVER_NAMESPACES.NOTIFICATIONS);

  const refetchRef = useRef(refetchNotification);

  useEffect(() => {
    refetchRef.current = refetchNotification;
  }, [refetchNotification]);

  useEffect(() => {
    if (!socket) return;

    const handleNotificationsUpdated = () => {
      refetchRef.current?.();
    };

    socket.on("notification:updated", handleNotificationsUpdated);

    return () => {
      socket.off("notification:updated", handleNotificationsUpdated);
    };
  }, [socket]);

  const emitNewNotification = (userIds = []) => {
    if (!socket) return;

    socket.emit("notification:new", { userIds });
  };

  return { emitNewNotification };
};

export default useNotificationSocket;
